import { useCallback } from "react";

import { useQuery } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

export function useUserTable() {
  const queryFactory = useCallback(() => {
    const query = `
      query getUserTable {
        advisors(showAll: true) {
          edges {
            node {
              uuid
              firstName
              lastName
              name
              email
              role {
                uuid
                title
              }
              status
              insightsEnabled
              isAccountOwner
              isSupport
            }
          }
        }
      }`;

    const resolver = ({ data: { advisors } }) => {
      return advisors.edges.map(({ node }) => {
        return {
          ...node,
          id: node.uuid,
          role: { ...node.role, id: node.role.uuid },
        };
      });
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, error, reloadData } = useQuery(queryFactory, {
    options: { fetchOnInit: false },
  });

  return {
    loading: loading,
    users: data,
    reloadData: reloadData,
    error: error
      ? error[0]?.message ||
        "Failed to load list of users for this practice’s hub. Please retry or contact support for assistance"
      : "",
  };
}

export default useUserTable;
